module.exports = __webpack_public_path__ + "media/layer3_720p_1.2236b959.webm";